import * as React from "react"
import { ChangeEvent } from "react" 
import { IPatientConcern } from "@curefit/ehr-common";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import * as _ from "lodash";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ModelFactory from "../../models/ModelFactory";
import * as $ from "jquery";
import DurationComponent from "../DurationComponent";
import TextAreaAutoResize from "../TextAreaAutoResize";

export interface IConcernItemEditorProps {
    item: IPatientConcern;
    onDataChange: (update: any) => any;
    fetchStaticSymptomData: (name: string) => Promise<any>;
}

export interface IConcernItemEditorState {
    validate: boolean;
}

class ConcernItemEditor extends React.Component<IConcernItemEditorProps, IConcernItemEditorState> {
    private concernItemDOM: any;

    constructor(props: IConcernItemEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.concernItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.concernItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onConcernFrequencyCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        let frequencyCount = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let updatedItem = { ...this.props.item, frequencyCount }
        this.props.onDataChange(updatedItem)
    };

    onConcernFrequencyUnitChange = (value: string) => {
        let updatedItem = { ...this.props.item, frequencyUnit: value }
        this.props.onDataChange(updatedItem)
    };

    onConcernFrequencyChange = (elem: TypeAheadElement) => {
        let duration = !_.isEmpty(elem.others.value) ? elem.others.value : { count: null, unit: null };
        let updatedItem = { ...this.props.item, frequencyCount: duration.count, frequencyUnit: duration.unit };
        this.props.onDataChange(updatedItem);
    }

    onConcernCommentChange = (event: React.SyntheticEvent<HTMLTextAreaElement>) => {
        let updatedItem = { ...this.props.item, comment: (event.target as HTMLTextAreaElement).value }
        this.props.onDataChange(updatedItem)
    };

    onConcernLastOccurenceCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        let lastOccurence = this.props.item.lastOccurence !== null ? this.props.item.lastOccurence : ModelFactory.createNewFrequency();
        lastOccurence.count = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let updatedItem = { ...this.props.item, lastOccurence }
        this.props.onDataChange(updatedItem);
    }

    onConcernLastOccurenceUnitChange = (value: string) => {
        let lastOccurence = this.props.item.lastOccurence !== null ? this.props.item.lastOccurence : ModelFactory.createNewFrequency();
        lastOccurence.unit = value;
        let updatedItem = { ...this.props.item, lastOccurence }
        this.props.onDataChange(updatedItem);
    }

    onConcernLastOccurenceChange = (elem: TypeAheadElement) => {
        let duration = elem.others.value;
        let updatedItem = { ...this.props.item, lastOccurence: duration };
        this.props.onDataChange(updatedItem);
    }

    onConcernTypeAheadChange = (input: string) => {
        let updatedItem = { ...this.props.item, displayValue: input, internalValue: input };
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticSymptomData(input).then(symptoms => {
            let symptomTypeAhead: TypeAheadElement[] = [];
            _.map(symptoms, (symptom) => {
                let typeAheadElement: TypeAheadElement = {
                    value: symptom.id,
                    label: symptom.name
                }
                symptomTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({options: symptomTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    }

    onConcernTypeAheadSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, displayValue: elem.label, internalValue: elem.value };
        this.props.onDataChange(updatedItem);
    }

    generateLastOccurenceListForCustomSelect(): IStaticDataValue[] {
        let list: IStaticDataValue[] = []
        _.map(AppConstants.FrequencyUnit, (value, key) => {
            let item = ModelFactory.createNewStaticItem();
            item.displayValue = value;
            item.internalValue = key;
            list.push(item);
        })
        return list;
    }

    generateFrequencyListItems() {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        })
        return frequencyList;
    }

    render() {
        let count = this.props.item.frequencyCount !== null ? this.props.item.frequencyCount : "" as any;
        let frequencyUnit = this.props.item.frequencyUnit !== null ? this.props.item.frequencyUnit : null;
        let lastOccurenceCount = this.props.item.lastOccurence !== null && this.props.item.lastOccurence !== undefined ? this.props.item.lastOccurence.count.toString() : "" as any;
        let lastOccurentUnit = this.props.item.lastOccurence !== null && this.props.item.lastOccurence !== undefined && this.props.item.lastOccurence.unit !== null ? this.props.item.lastOccurence.unit : null;
        let dropdownList = this.generateLastOccurenceListForCustomSelect();
        let concernNameValidationStatus = this.state.validate && _.isEmpty(this.props.item.displayValue) ? "error" : "";
        return (
            <div  className="concern-item-editor" style={{ width: "100%" }} ref={(concernItemDOM) => this.concernItemDOM = concernItemDOM}>
                <div className={`concern-editor-trouble ${concernNameValidationStatus}`}>
                    <TypeAhead widgetName={"ConcernItem"} name={"concern-trouble"} value={this.props.item.displayValue || ""} placeholder={AppPlaceholders.CONCERNS_EDITVIEW_TROUBLE} onTypeAheadChange={this.onConcernTypeAheadChange} onTypeAheadSelect={this.onConcernTypeAheadSelect}/>
                </div>
                <div className="concern-editor-lastOccurence">
                    <DurationComponent unit={lastOccurentUnit} count={lastOccurenceCount || ""} dropdownItems={this.generateFrequencyListItems()}
                                       rootClass={"lastOccurence"} onCountChange={this.onConcernLastOccurenceCountChange}
                                       onUnitChange={this.onConcernLastOccurenceUnitChange} onDurationChange={this.onConcernLastOccurenceChange}/>
                </div>
                <div className="concern-editor-frequency">
                    <DurationComponent unit={frequencyUnit} count={count} dropdownItems={this.generateFrequencyListItems()}
                                       rootClass={"concern"} onCountChange={this.onConcernFrequencyCountChange} isFrequency={true}
                                       onUnitChange={this.onConcernFrequencyUnitChange} onDurationChange={this.onConcernFrequencyChange}/>
                </div>
                <div className="concern-editor-comment">
                    <TextAreaAutoResize
                        name={"concern-editor-comment"}
                        className={"textarea-input form-control"}
                        value={this.props.item.comment || ""}
                        placeholder={AppPlaceholders.CONCERNS_EDITVIEW_LAST_COMMENTS}
                        onChange={this.onConcernCommentChange}
                        rows={2}
                    />
                </div>
            </div>
        )
    }
}

export default ConcernItemEditor;
